export default {
  en: {
    login: {
      name: 'Name',
      email: 'Email',
      password: 'Password',
      loginText: 'Login',
      forgotPassword: 'Forgot your password?',
      emailPlaceholder: 'name@company.com',
      haveAccount: "You You don't have account?",
      registerHere: 'Register Here',
      loginFailed: 'Incorrect email or password',
      verifyCaptcha: 'Verify Captcha',
      expiredCaptcha: 'Captcha has expired'
    },
    signup: {
      registerText: 'Sign Up',
      password: 'Password',
      registerButton: 'Register',
      haveAccount: 'Do you already have an account?',
      login: 'Login',
      logout: 'Logout',
      acceptTerms: 'By creating an <b>tikket</b> account, accept our <a href="">Terms of Service</a> and <a href="">Privacy Policy</a>.',
      emailRegistered: 'This email is already registered, please login',
      veryWeakMessage: 'So Easy',
      weakMessage: 'Weak',
      mediumMessage: 'Is acceptable',
      goodMessage: 'Strong Pass',
      greatMessage: 'Very Strong'
    },
    recoveryPassword: {
      gobackLogin: 'Go back to Login'
    },
    getstarted: {
      workspaceName: 'Whats is your workspace name?',
      explainUse: 'We will use it to name your workspace in <b>tikkets</b>',
      getStartedButton: 'Create your workspace',
      urlError: 'An error occurred with the design of the url, try again',
      duplicateUrl: 'This name is already in use'
    },
    tikkets: {
      messageHelp: 'press <b>Shift+Enter</b> to send the message',
      newTikket: 'New tikket',
      addTikket: 'Add tikket',
      finishTikket: 'Finish tikket',
      delay: 'Delay'
    },
    messages: {
      newMessage: 'New message',
      send: 'Send'
    },
    user: {
      myAccount: 'My account',
      selectAvatar: 'Select avatar'
    },
    tour: {
      skip: 'Skip tour',
      previous: 'Previous',
      next: 'Next',
      finish: 'Finish',
      userMenuHeader: '<b>Manage your account</b>',
      userMenuContent: 'This is the <strong>user menu</strong>, here you can manage your account.',
      workspacesHeader: '<b>Workspaces</b>',
      workspacesContent: 'Here you can see the list of <strong>workspaces</strong> that you have access.',
      tikketsHeader: '<b>Create a <strong>tikket</strong></b>',
      tikketsontent: 'Press here to create a tikket.',
      menuHeader: '<b>Tour completed!</b>',
      menuContent: 'Explore <b>more options</b> or show this <strong>help</strong> again if you <b class="has-text-danger">lose da wae</b>.'
    },
    general: {
      termsConditions: 'Terms & Conditions',
      privacyPolicies: 'Privacy Policies',
      tryAgain: 'Try Again',
      notValidEmail: 'Please use a valid email',
      subject: 'Subject',
      type: 'Type',
      priority: 'Priority',
      description: 'Description',
      attachments: 'Attachments',
      dragUpload: 'Drop your files here or click to upload',
      accept: 'Accept',
      cancel: 'Cancel',
      close: 'Close',
      expand: 'Expand',
      compress: 'Compress',
      submit: 'Submit',
      help: 'Help',
      collaborators: 'Collaborators',
      you: 'You',
      hours: 'Hours',
      minutes: 'Minutes',
      message: 'Message'
    }
  },
  es: {
    login: {
      name: 'Nombre',
      email: 'Email',
      password: 'Contraseña',
      loginText: 'Iniciar Sesión',
      forgotPassword: '¿Olvidaste tu contraseña?',
      emailPlaceholder: 'nombre@empresa.com',
      haveAccount: '¿No tienes cuenta?',
      registerHere: 'Registrate aquí',
      loginFailed: 'Email o Contraseña Incorrecta',
      verifyCaptcha: 'Verificar Captcha',
      expiredCaptcha: 'El Captcha ha expirado'
    },
    signup: {
      registerText: 'Registrate',
      password: 'Contraseña',
      registerButton: 'Registrar',
      haveAccount: '¿Ya tienes una cuenta?',
      login: 'Iniciar Sesión',
      logout: 'Cerrar sesión',
      acceptTerms: 'Al crear una cuenta <b>tikket</b>, acepta nuestros <a href="">Términos de servicio</a> y <a href="">Política de privacidad</a>',
      emailRegistered: 'Este correo electrónico ya está registrado, por favor inicie sesión.',
      veryWeakMessage: 'Muy facil',
      weakMessage: 'Debil',
      mediumMessage: 'Es aceptable',
      goodMessage: 'Fuerte',
      greatMessage: 'Muy fuerte'
    },
    recoveryPassword: {
      gobackLogin: 'Volver al inicio de sesión',
      actionButton: 'Recuperar Contraseña'
    },
    getstarted: {
      workspaceName: '¿Cómo se llama tu empresa?',
      explainUse: 'Lo usaremos para ponerle un nombre a tu espacio de trabajo en <b>tikkets</b>',
      getStartedButton: 'Crea tu espacio de trabajo',
      urlError: 'Ha ocurrido un error con el diseño de la url, intenta de nuevo',
      duplicateUrl: 'Este nombre ya está en uso'
    },
    tikkets: {
      messageHelp: 'presiona <b>Shift+Enter</b> para enviar el mensaje',
      newTikket: 'Nuevo tikket',
      addTikket: 'Agregar tikket',
      tikketType: 'Tipo de tikket',
      finishTikket: 'Finalizar tikket',
      delay: 'Duración'
    },
    messages: {
      newMessage: 'Nuevo mensaje',
      send: 'Enviar'
    },
    user: {
      myAccount: 'Mi cuenta',
      selectAvatar: 'Seleccionar avatar'
    },
    tour: {
      skip: 'Omitir tour',
      previous: 'Anterior',
      next: 'Siguiente',
      finish: 'Finalizar',
      userMenuHeader: '<b>Administra tu cuenta</b>',
      userMenuContent: 'Este es el <strong>menú de usuario</strong>, aqui puedes gestionar tu cuenta.',
      workspacesHeader: '<b>Espacios de trabajo</b>',
      workspacesContent: 'Aquí podras ver la lista de <strong>espacios de trabajo</strong> a los que tienes acceso.',
      tikketsHeader: '<b>Crea un <strong>tikket</strong></b>',
      tikketsontent: 'Presiona aqui para crear un tikket.',
      menuHeader: '<b>Tour completado!</b>',
      menuContent: 'Explora <b>más opciones</b> o accede a esta <strong>ayuda</strong> nuevamente.'
    },
    general: {
      termsConditions: 'Términos y condiciones',
      privacyPolicies: 'Política de privacidad',
      tryAgain: 'Entendido',
      notValidEmail: 'Introduzca un email valido',
      subject: 'Asunto',
      type: 'Tipo',
      priority: 'Prioridad',
      description: 'Descripción',
      attachments: 'Adjuntos',
      dragUpload: 'Arrastra tus archivos o presiona click',
      accept: 'Aceptar',
      cancel: 'Cancelar',
      close: 'Cerrar',
      expand: 'Expander',
      compress: 'Contraer',
      submit: 'Enviar',
      help: 'Ayuda',
      collaborators: 'Colaboradores',
      you: 'Tú',
      hours: 'Horas',
      minutes: 'Minutos',
      message: 'Mensaje'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang.js